import { isEmpty, isNil } from 'lodash';
import { setUa } from '../parse';

// export const checkDeviceType = (type: DeviceTypes):  => {
//   switch (type) {
//     case DeviceTypes.Mobile:
//       return { isMobile: true };
//     case DeviceTypes.Tablet:
//       return { isTablet: true };
//     case DeviceTypes.SmartTv:
//       return { isSmartTV: true };
//     case DeviceTypes.Console:
//       return { isConsole: true };
//     case DeviceTypes.Wearable:
//       return { isWearable: true };
//     case DeviceTypes.Browser:
//       return { isBrowser: true };
//     case DeviceTypes.Embedded:
//       return { isEmbedded: true }
//     default:
//       return InitialDeviceTypes;
//   }
// };

// export const getCurrentBrowser = (name) => {
//   switch (name) {
//     case BrowserTypes.Chrome:
//     case BrowserTypes.Opera:
//     case BrowserTypes.Firefox:
//     case BrowserTypes.Yandex:
//     case BrowserTypes.Safari:
//     case BrowserTypes.Ie:
//     case BrowserTypes.Edge:
//     case BrowserTypes.Chromium:
//       return true;
//     default:
//       return false;
//   }
// };

export const setUserAgent = (userAgent: string): UAParser.UAParserInstance =>
  setUa(userAgent);

// export const mockUserAgent = (userAgent: string) => {
//   window.navigator.__defineGetter__('userAgent', () => userAgent);
// };

export const setDefaults = (p: string | undefined, d = 'none'): string =>
  !isEmpty(p) ? (p as string) : d;

export const getNavigatorInstance = (): Navigator | undefined => {
  if (!isNil(window)) {
    if (!isNil(window.navigator) || !isNil(navigator)) {
      return (window.navigator as Navigator | undefined) ?? navigator;
    }
  }

  return undefined;
};

export const isIOS13Check = (type: string): boolean => {
  const nav = getNavigatorInstance();
  return (
    !isNil(nav) &&
    !isNil(nav.platform) &&
    (nav.platform.includes(type) ||
      (nav.platform === 'MacIntel' &&
        nav.maxTouchPoints > 1 &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isNil((window as any).MSStream)))
  );
};
